// extracted by mini-css-extract-plugin
export default {"filtersContainer":"course-filters_filtersContainer__5m+me","dropdownContainer":"course-filters_dropdownContainer__mowiA","marginRight10":"course-filters_marginRight10__9lxZZ"};